import { render, staticRenderFns } from "./saf-tab.vue?vue&type=template&id=e8ab28fc"
import script from "./saf-tab.vue?vue&type=script&lang=js"
export * from "./saf-tab.vue?vue&type=script&lang=js"
import style0 from "./saf-tab.vue?vue&type=style&index=0&id=e8ab28fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports